import { Directive, Input, OnInit, OnDestroy, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { UserPreferenceStoreService } from './UserPreferenceStore.Service';
import { USER_PREFERENCE_KEY } from './UserPreference.Contract';

@Directive({
	selector: '[vbUserPreferenceStore]',
	standalone: true
})
export class VbUserPreferenceStoreDirective implements OnInit, OnDestroy {
	@Input() public key: USER_PREFERENCE_KEY;
	private subscription: Subscription;

	constructor(
		@Self() private readonly ngControl: NgControl,
		private readonly UserPreferenceStoreService: UserPreferenceStoreService
	) {}

	public ngOnInit(): void {
		if (!this.key) {
			return;
		}

		this.subscription = this.ngControl.valueChanges?.subscribe(value => {
			if (this.ngControl.untouched || this.ngControl.invalid) {
				return;
			}
			this.UserPreferenceStoreService.setPreference(this.key, value);
		});
	}

	public ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}
}
